import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaTruck,
  FaRoute,
  FaMapMarkerAlt,
  FaUsers,
  FaFileInvoiceDollar,
  FaChartLine,
  FaMobile,
  FaShippingFast,
  FaClock,
  FaDownload,
  FaCheckCircle,
  FaStar,
  FaArrowRight,
} from "react-icons/fa";
import "./SupportPage.css";

const SupportPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const features = [
    {
      icon: FaShippingFast,
      title: "Sledovanie zásielok",
      description:
        "Sledovanie zásielok v reálnom čase s automatickými notifikáciami pre klientov",
    },
    {
      icon: FaTruck,
      title: "Správa vozového parku",
      description: "Kompletná evidencia vozidiel, servisu a pohonných hmôt",
    },
    {
      icon: FaRoute,
      title: "Optimalizácia trás",
      description:
        "Inteligentné plánovanie trás pre minimalizáciu nákladov a času",
    },
    {
      icon: FaFileInvoiceDollar,
      title: "Fakturácia dopravy",
      description: "Automatické generovanie faktúr a výpočet dopravného",
    },
    {
      icon: FaUsers,
      title: "CRM pre klientov",
      description: "Správa zákazníkov a ich zákaziek s históriou spolupráce",
    },
    {
      icon: FaMapMarkerAlt,
      title: "GPS integrácia",
      description:
        "Napojenie na GPS systémy pre presné sledovanie polohy vozidiel",
    },
  ];

  const benefits = [
    {
      icon: FaClock,
      title: "Úspora času",
      value: "40%",
      description: "Zníženie času potrebného na administratívu",
    },
    {
      icon: FaChartLine,
      title: "Zvýšenie efektivity",
      value: "35%",
      description: "Optimalizácia trás a využitia vozového parku",
    },
    {
      icon: FaFileInvoiceDollar,
      title: "Presnosť fakturácie",
      value: "99%",
      description: "Automatické a presné výpočty dopravného",
    },
    {
      icon: FaUsers,
      title: "Spokojnosť klientov",
      value: "95%",
      description: "Transparentnosť a rýchlosť dodávok",
    },
  ];

  const modules = [
    {
      name: "Základný modul",
      price: "199€",
      description: "Pre menšie prepravné firmy",
      features: [
        "Základná evidencia zásielok",
        "Faktúry a cenníky",
        "Správa klientov",
        "Základné reporty",
        "Do 2 vozidiel",
      ],
    },
    {
      name: "Profesionálny modul",
      price: "399€",
      description: "Pre stredné logistické firmy",
      features: [
        "Všetky funkcie základného modulu",
        "GPS sledovanie",
        "Optimalizácia trás",
        "Pokročilé reporty",
        "Do 10 vozidiel",
        "Mobilná aplikácia",
      ],
      popular: true,
    },
    {
      name: "Enterprise modul",
      price: "699€",
      description: "Pre veľké logistické spoločnosti",
      features: [
        "Všetky funkcie profesionálneho modulu",
        "API integrácie",
        "Pokročilá analytika",
        "Multi-pobočkový systém",
        "Neobmedzený počet vozidiel",
        "Prioritná podpora 24/7",
      ],
    },
  ];

  const testimonials = [
    {
      name: "Marián Kováč",
      company: "TRANS-SPEED s.r.o.",
      text: "Špedícia nám výrazne zjednodušila správu našej flotily. Úspora času je ohromná.",
      rating: 5,
    },
    {
      name: "Jana Novotná",
      company: "LogiSTAR Ltd.",
      text: "Optimalizácia trás nám ušetrila 30% nákladov na pohonné hmoty.",
      rating: 5,
    },
  ];

  return (
    <div className="support-page">
      {/* Hero Section */}
      <section className="support-hero">
        <div className="hero-text">
          <h1>Podpora</h1>
        </div>
      </section>

      <iframe
        id="blockrandom"
        name="iframe"
        src="https://podpora.inver.sk/index.php?w=login"
        width="100%"
        height="550px"
        scrolling="auto"
        frameBorder="0"
        className="wrapper"
        title="Podpora INVER"
        style={{ border: 0 }}
      >
        Táto možnosť nebude fungovať správne. Váš webový prehliadač žiaľ
        nepodporuje vnorené rámi.
      </iframe>
    </div>
  );
};

export default SupportPage;
